import { Directive, ElementRef, HostListener, Input, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[DateFormat]'
})
export class DateFormatDirective {

    @Input() DateFormat: string;
    @Input() ngModel: string;
    @Input() emitDate: string;

    @Output() dateValueChanged: EventEmitter<any> = new EventEmitter<any>();

    newValue = "";
    inter: any = [];
    temp = '';

    constructor(private el: ElementRef) { }

    @HostListener("input", ["$event"])
    onKeyPress(event: InputEvent) {
        let value: string = this.el.nativeElement.getElementsByClassName("mdl-textfield__input")[0].value;

        switch (this.DateFormat) {
            case "date":
                this.newValueFormat(value, event);

                if ((this.newValue.slice(-1) === '/' && value.length > 7) || this.newValue.slice(-2) === '//') {
                    this.newValue = this.newValue.substring(0, this.newValue.length-1);
                }

                this.el.nativeElement.getElementsByClassName("mdl-textfield__input")[0].value = this.newValue;

                if (this.emitDate) {
                    this.dateValueChanged.emit(this.newValue);
                }
                break;
            default:
                break;
        }
    }

    newValueFormat(value: any, event: any) {
        this.newValue = value.replace(/[^\d+(\/\d+)*$]/g, "");
        if (value.length == 2 || value.length === 5) {
            this.inter = this.newValue.split('/');
            if (this.newValue.slice(-1) === '/') {
                for (let i = 0;  i <= this.inter.length; i++) {
                    if (this.inter[i] && this.inter[i].length === 1) {
                        this.inter[i] = '0'+ this.inter[i];
                        this.temp = this.inter[i] + '/'
                    }
                }
                this.newValue = this.newValue.substring(0, this.newValue.length-2) + this.temp
            }

            if (event.inputType === "deleteContentBackward") {
                this.newValue = this.newValue.slice(0, this.newValue.length - 1);
            } else if (this.newValue.slice(-1) !== '/') {
                this.newValue = this.newValue + "/";
            }
        }
    }
}